export const HW_PACKAGE_FORM_ID = 'hw-package-form';
